export default __webpack_public_path__ + "static/media/key_skeleton.3652c5c6.svg";